import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import {
    AdAssetFormatId,
    AdAssetPreviewBboxLarge,
    AdAssetPreviewBboxLargeForLink,
    AdAssetPreviewBboxSmall,
    AdAssetPreviewButtonLinkImgPath,
    AdAssetPreviewClockIconUrl,
    AdAssetPreviewCommonAreaNames,
    AdAssetPreviewCustomAreaNames,
    AdAssetPreviewDipsTime,
    AdAssetPreviewFooterFreeIconUrl,
    AdAssetPreviewHeaderIconUrl,
    AdAssetPreviewMemoBegin,
    AdAssetContact,
    AdAssetPreviewSetting,
    AdAssetPreviewSingleAreaNames,
    AdAssetPreviewSubjectIconUrl,
    AdAssetPreviewTextConfigText,
    AdAssetPreviewTextConfigTextForLink,
    CommonItems,
    CustomItems,
    initButtonLinkItem,
    initImageItem,
    initSectionItem,
    initTextItem,
    initTextLinkItem,
    MailData,
    SingleItems,
} from "./common/AdAssetModel";
import {CardHeader} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {convertBrTag} from "../../../common/Apollo_CommonUtil";
import {apollo_useStyles} from "../../../atom/Apollo_styles";

export const apollo_msPreviewStyles = makeStyles({


    previewLine: {
        margin: 2,
        lineHeight: 100,
        backgroundColor: (props: any) => props.lineColor,
    },

    previewText: {
        padding: "2px",
        margin: 2,
        fontSize: 14,
        color: (props: any) => props.color,
        textAlign: (props: any) => props.textPos,
        textDecoration: (props: any) => props.textDecoration,
        textDecorationColor: (props: any) => props.textDecorationColor,
    },

    previewBox: {
        padding: (props: any) => props.padding,
        textAlign: "center",
        borderStyle: "dashed",
        borderWidth: 2,
        margin: 8,
        borderColor: "black",
        color: (props: any) => props.color,
        textDecoration: (props: any) => props.textDecoration,
        textDecorationColor: (props: any) => props.textDecorationColor,
    },
});

const AdAssetPreview: React.FC<{
    mailData: MailData
}>
    = ({
           mailData
       }
) => {

    // style
    const classes = apollo_useStyles();
    const previewBoxLargeStyle = apollo_msPreviewStyles({...AdAssetPreviewBboxLarge}).previewBox

    // formatId
    const formatId = mailData.commonItems.formatId;
    // judge edited
    const displayBlankArea = isDisplayBlankArea(mailData)

    // useEffect
    return (
        <Card>
            <CardHeader
                style={{backgroundColor: "#EEE", padding: "3px", marginLeft: "5px"}}
                title="プレビュー"
                titleTypographyProps={{variant: "h6"}}
            />
            <CardContent className={classes.msPreviewText}>
                <Grid container style={{marginBottom: "60px", marginTop: "0px"}} spacing={1}>
                    <Grid item xs={12} style={{height: "30px", width: "100%"}}>
                        <img src={AdAssetPreviewHeaderIconUrl} alt="setting" style={{height: "70px", width: "100%"}}/>
                    </Grid>
                </Grid>
                <Divider/>
                <Grid container style={{height: "20px", marginBottom: "10px"}} spacing={1}>
                    <Grid item xs={1} style={{height: "30px"}}>
                        <img src={AdAssetPreviewClockIconUrl} alt="setting" height="auto" width="25"/>
                    </Grid>
                    <Grid item xs={11}>
                        {AdAssetPreviewDipsTime}
                    </Grid>
                </Grid>
                <Divider/>
                <Grid container style={{height: "20px", marginBottom: "10px"}} spacing={1}>
                    <Grid item xs={1} style={{height: "30px"}}>
                        <img src={AdAssetPreviewSubjectIconUrl} alt="setting" height="auto" width="25"/>
                    </Grid>
                    <Grid item xs={11}>
                        {mailData.commonItems.subject}
                    </Grid>
                </Grid>
                <Divider/>
                <Card style={{fontSize: "1.0em"}}>
                    <CardContent style={{padding: "2"}}>
                        {formatId === AdAssetFormatId.single ?
                            <AdAssetPreviewSingle
                                commonItems={mailData.commonItems}
                                singleItems={mailData.singleItems}
                                isDisplayBlankArea={displayBlankArea}
                            /> :
                            formatId === AdAssetFormatId.custom ?
                                <AdAssetPreviewCustom
                                    commonItems={mailData.commonItems}
                                    customItems={mailData.customItems}
                                    isDisplayBlankArea={displayBlankArea}
                                /> :
                                <></>
                        }
                        {displayBlankArea ?
                            <div className={previewBoxLargeStyle}>{AdAssetPreviewCommonAreaNames.linkButton}</div>
                            :
                            (mailData.commonItems.buttonLinkItem.labelType !== "" ?
                                    <div style={{textAlign: "center"}}>
                                        <img src={getLinkButtonImgUrl(mailData.commonItems.buttonLinkItem.labelType,
                                            mailData.commonItems.buttonLinkItem.colorType)}
                                             style={{width: "70%", height: "50px"}}/>
                                    </div> : <></>
                            )
                        }
                        <Divider/>
                        <Grid container style={{marginBottom: "5px", marginTop: "5px"}} spacing={1}>
                            <Grid item xs={12}>
                                提供：{mailData.commonItems.notation}
                            </Grid>
                        </Grid>
                        <Divider/>
                        <Grid container style={{marginBottom: "5px", marginTop: "5px"}} spacing={1}>
                            <Grid item xs={12}>
                                {convertBrTag(AdAssetPreviewMemoBegin)}<br/>

                                {AdAssetContact.preLabel}<a href={AdAssetContact.url}>{AdAssetContact.label}</a><br/>
                                {AdAssetPreviewSetting.preLabel}<a href={AdAssetPreviewSetting.url}>{AdAssetPreviewSetting.label}</a>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </CardContent>
        </Card>)
}

const isDisplayBlankArea = (
    mailData: MailData
) => {

    let displayBlankArea = false

    if (mailData.commonItems.formatId === AdAssetFormatId.single) {
        displayBlankArea =
            mailData.singleItems.imageItem.imageUrl === initImageItem.imageUrl &&
            mailData.singleItems.textLinkItem1.text === initTextLinkItem.text &&
            mailData.singleItems.textLinkItem2.text === initTextLinkItem.text &&
            mailData.singleItems.textItem.text === initTextItem.text

    } else if (mailData.commonItems.formatId === AdAssetFormatId.custom) {

        for (let sectionItem of mailData.customItems.sectionItems) {
            displayBlankArea =
                sectionItem.imageUrl == initSectionItem.imageUrl &&
                sectionItem.enableLine == initSectionItem.enableLine &&
                sectionItem.shortText == initSectionItem.shortText &&
                sectionItem.largeText == initSectionItem.largeText &&
                sectionItem.textLink == initSectionItem.textLink

            if (!displayBlankArea) break;
        }
    }

    displayBlankArea = displayBlankArea && mailData.commonItems.buttonLinkItem.labelType === initButtonLinkItem.labelType
    return displayBlankArea;
}

const getLinkButtonImgUrl = (label: string, color: string) => {
    return label && color ? `${AdAssetPreviewButtonLinkImgPath}/${label}/${color}.gif` : ""
}

const AdAssetPreviewSingle: React.FC<{
    commonItems: CommonItems,
    singleItems: SingleItems,
    isDisplayBlankArea: Boolean,
}> = ({commonItems, singleItems, isDisplayBlankArea}) => {

    const textStyle = apollo_msPreviewStyles({
        ...AdAssetPreviewTextConfigText,
        textPos: commonItems.textPosType
    }).previewText
    const textForLinkStyle = apollo_msPreviewStyles({
        ...AdAssetPreviewTextConfigTextForLink,
        textPos: "center"
    }).previewText

    const previewBoxLargeSytyle = apollo_msPreviewStyles({...AdAssetPreviewBboxLarge}).previewBox
    const previewBoxLargeForLinkSytyle = apollo_msPreviewStyles({...AdAssetPreviewBboxLargeForLink}).previewBox

    return (
        <React.Fragment>
            {isDisplayBlankArea ?
                <React.Fragment>
                    <div className={previewBoxLargeSytyle}>{AdAssetPreviewSingleAreaNames.image1}</div>
                    <div className={previewBoxLargeForLinkSytyle}>{AdAssetPreviewSingleAreaNames.textLink1}</div>
                    <div className={previewBoxLargeSytyle}>{AdAssetPreviewSingleAreaNames.textLong1}</div>
                    <div className={previewBoxLargeForLinkSytyle}>{AdAssetPreviewSingleAreaNames.textLink2}</div>
                </React.Fragment>
                :
                <React.Fragment>
                    {singleItems.imageItem.imageUrl !== "" ?
                        <img src={singleItems.imageItem.imageUrl} style={{width: '100%'}}/> : <></>}
                    {singleItems.textLinkItem1.text !== "" ?
                        <div className={textForLinkStyle}>{convertBrTag(singleItems.textLinkItem1.text)}</div> : <></>}
                    {singleItems.textItem.text !== "" ?
                        <div className={textStyle}>{convertBrTag(singleItems.textItem.text)}</div> : <></>}
                    {singleItems.textLinkItem2.text !== "" ?
                        <div className={textForLinkStyle}>{convertBrTag(singleItems.textLinkItem2.text)}</div> : <></>}
                </React.Fragment>
            }
        </React.Fragment>
    )
}

const AdAssetPreviewCustom: React.FC<{
    commonItems: CommonItems,
    customItems: CustomItems,
    isDisplayBlankArea: Boolean,
}> = ({commonItems, customItems, isDisplayBlankArea}) => {

    const textStyle = apollo_msPreviewStyles({
        ...AdAssetPreviewTextConfigText,
        textPos: commonItems.textPosType
    }).previewText
    const textForLinkStyle = apollo_msPreviewStyles({
        ...AdAssetPreviewTextConfigTextForLink,
        textPos: "center"
    }).previewText
    const lineStyle = apollo_msPreviewStyles({lineColor: customItems.lineColor}).previewLine

    const previewBoxSmallStyle = apollo_msPreviewStyles({...AdAssetPreviewBboxSmall}).previewBox
    const previewBoxLargeStyle = apollo_msPreviewStyles({...AdAssetPreviewBboxLarge}).previewBox
    const previewBoxLargeForLinkStyle = apollo_msPreviewStyles({...AdAssetPreviewBboxLargeForLink}).previewBox

    return (
        <React.Fragment>
            {customItems.sectionItems.map((sectionItem, index) => {

                    return (
                        isDisplayBlankArea ?
                            <React.Fragment>
                                <div
                                    className={previewBoxLargeStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.image1}`}</div>
                                <div
                                    className={previewBoxSmallStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.line1}`}</div>
                                <div
                                    className={previewBoxLargeStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.textShort1}`}</div>
                                <div
                                    className={previewBoxSmallStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.line2}`}</div>
                                <div
                                    className={previewBoxLargeStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.textLong1}`}</div>
                                <div
                                    className={previewBoxLargeForLinkStyle}>{`セクション${index + 1} ${AdAssetPreviewCustomAreaNames.textLink1}`}</div>
                            </React.Fragment> :
                            <React.Fragment>
                                {sectionItem.imageUrl !== "" ?
                                    <img src={sectionItem.imageUrl} style={{width: '100%'}}/> : <></>}
                                {sectionItem.enableLine ? <Divider className={lineStyle}/> : <></>}
                                {sectionItem.shortText !== "" ?
                                    <div className={textStyle}>{convertBrTag(sectionItem.shortText)}</div> : <></>}
                                {sectionItem.enableLine ? <Divider className={lineStyle}/> : <></>}
                                {sectionItem.largeText !== "" ?
                                    <div className={textStyle}>{convertBrTag(sectionItem.largeText)}</div> : <></>}
                                {sectionItem.textLink !== "" ?
                                    <div className={textForLinkStyle}>{convertBrTag(sectionItem.textLink)}</div> : <></>}
                            </React.Fragment>
                    )
                }
            )
            }
        </React.Fragment>
    )
}

export default AdAssetPreview
